import React, { Component } from "react";
import { Routing } from "./Routing";
import { connect } from "react-redux";
import { Promo, Header } from "components/Header";
import { Footer } from "components/Footer";
import { BrowserRouter } from "react-router-dom";
import { ScrollToTop } from "components/ScrollToTop";
import {
  getGuestCartId,
  setGuestCartId,
  getGuestCartProducts
} from "./Cart/actions";

class App extends Component {
  componentDidMount = () => {
    const { getCartIdFromLocalstorage } = this;
    const { getGuestCartId, setGuestCartId, getGuestCartProducts } = this.props;

    const cartId = getCartIdFromLocalstorage();
    if (cartId === null || cartId === undefined) {
      getGuestCartId();
    } else {
      setGuestCartId(cartId);
      getGuestCartProducts(cartId);
    }
  };

  getCartIdFromLocalstorage = () => {
    const cartId = sessionStorage.getItem("cartId");
    return cartId ? cartId : null;
  };

  updateLocalStorage = newState => {
    sessionStorage.setItem("cartId", newState);
  };

  render() {
    return (
      <div className="pageWrapper">
        <BrowserRouter>
          <ScrollToTop>
            <Promo />
            <Header />
            <main className="contentWrapper">
              <Routing />
            </main>
            <Footer />
          </ScrollToTop>
        </BrowserRouter>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { cartId, cartProducts, cartPrice, cartQty } = state.cartReducer;

  return {
    cartId: cartId,
    cartProducts: cartProducts,
    cartPrice: cartPrice,
    cartQty: cartQty
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getGuestCartId: () => dispatch(getGuestCartId()),
    setGuestCartId: cartId => dispatch(setGuestCartId(cartId)),
    getGuestCartProducts: cartId => dispatch(getGuestCartProducts(cartId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/modules/App.jsx